import { PageViewEventLogger } from '@repo/tracking-service';

import { PersonalDeductionCollectCompletedContainer } from '@/components/tax-refund/collect/result/PersonalDeductionCollectCompletedContainer';

function CollectCompletedPage() {
  return (
    <PageViewEventLogger pageName={'personal-deduction-complete'}>
      <PersonalDeductionCollectCompletedContainer />
    </PageViewEventLogger>
  );
}

export default CollectCompletedPage;
